import React, { useEffect, useState } from 'react';
import {
    Card,
    CardActionArea,
    CardActions,
    CardContent,
    CircularProgress,
    Grid,
    Typography
} from '@material-ui/core';
import StorefrontIcon from '@material-ui/icons/Storefront';
import { getMarkets } from '../api';
import { truncate } from 'helpers/text';

const Market = ({ setMarket }) => {
    const [markets, setMarkets] = useState([]);
    const [loading, setLoading] = useState(true);

    const getData = () => {
        getMarkets()
            .then(res => setMarkets(res.data))
            .catch(err => alert(err))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (loading) {
            getData();
        }
    }, [loading]);

    return (
        <Grid
            container
            direction="row"
            alignContent="center"
            justifyContent="center"
            justify="center"
            alignItems="center"
            spacing={2}>
            {loading ? (
                <CircularProgress size={35} style={{ margin: 20 }} />
            ) : (
                markets.map(market => (
                    <Grid item xs={6} key={market.id}>
                        <CardActionArea onClick={() => setMarket(market)}>
                            <Card elevation={1}>
                                <div style={{ padding: 8 }}>
                                    <Typography
                                        variant="button"
                                        color="primary"
                                        style={{ fontSize: 12 }}>
                                        {truncate(market.libelleMarche, 30)}
                                    </Typography>
                                </div>
                                <CardContent style={{ padding: 8 }}>
                                    <Grid
                                        container
                                        justify="center"
                                        alignItems="center"
                                        justifyContent="center">
                                        <Grid item>
                                            <StorefrontIcon
                                                color="primary"
                                                style={{ fontSize: 35 }}
                                            />
                                        </Grid>
                                    </Grid>
                                </CardContent>
                                <CardActions>
                                    <Grid
                                        container
                                        direction="row"
                                        spacing={2}
                                        justifyContent="space-between"
                                        justify="space-between">
                                        <Grid item>
                                            <Typography variant="body2">{market.jour}</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="body2" style={{ fontWeight: 500 }}>
                                                {market.nbPlaces} places
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </CardActions>
                            </Card>
                        </CardActionArea>
                    </Grid>
                ))
            )}
        </Grid>
    );
};

export default Market;
